import { Services as CommunicationServices } from '@smiles/core-communication';

import type { ShowcaseData } from '../../Types';

export const getShowcases = async () => {
  let output: ShowcaseData[] = [];

  try {
    const { data } = await CommunicationServices.getProdConfigService({ ProductConfigId: 'hotels-showcases' });

    // @ts-ignore
    output = data.payload;
  } catch (error) {
    console.error(error);
    return [];
  }

  return output;
};
